shadow$provide[422] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getTriangleRightMask(vec2 uv) {
  uv.x -= .25;
  return max(-uv.x, abs(uv.y) * .866 + uv.x * .5 + .6);
}
`;

};